import envConfig from '../config.json'

export const env = (typeof window !== "undefined" && (window as any).__ASCA_CONFIG__) || envConfig as any;
